import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "mb-4 mt-8 text-grey" }
const _hoisted_8 = { class: "block w-full" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_10 = { class: "flex justify-end" }

import {Store} from "@bryntum/grid";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/GridInputFilter";
import {useGlobalStore} from "@/stores/GlobalStore";
import {onMounted, reactive, computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import {$t} from "@/utilities/i18n/config";
import {PopupType, TableType} from "@/utilities/enums/Enums";
import {useProviderStore} from "@/stores/ProviderStore";
import {checkboxColumnConfig} from "@/AppConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarCompaniesSelectionPopup',
  setup(__props) {

const gridStore = new Store();
const { t } = useI18n();
const globalStore = useGlobalStore();
const providerStore = useProviderStore();

const currentSelectedProviderCompany = computed(()=>{
  return globalStore.modal.contentObject.selectedProviderCompany
});

const openEditWithEnteredCompanyData = ()=>{
  console.log("on on back", globalStore.modal.contentObject.suggestedProviderCompany)
  globalStore.openPopup({
    data:   globalStore.modal.contentObject.suggestedProviderCompany,
    action: providerStore.addOrUpdateProvider,
    resetButton: false,
    title:$t("popups.providerManagement.new"),
    type:PopupType.providerManagementEditPopup
  });
}

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  autoHeight: true,
  columns : {
    data: [
      { id: 'name', field: 'name', text: t('providerManagement.grid.companyName'), flex: 1, },
      { id: 'address', field: 'address', text: t('providerManagement.grid.adress'), flex: 2, },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.similarCompany], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    multiSelect: false,
    checkbox: checkboxColumnConfig,
    showCheckAll : true
  },
  listeners: {
    selectionChange(event) {
      const hasSelection = event.selection.length > 0 && event.selection[0]?.data !== undefined;
      globalStore.modal.contentObject.selectedProviderCompany = hasSelection
          ? event.selection.map(lr => lr.data)[0]
          : globalStore.modal.contentObject.suggestedProviderCompany;
    }
  },
}
const gridConfig = reactive(useGridConfig);

onMounted(()=> {
  console.log("on mount", globalStore.modal.contentObject.suggestedProviderCompany)
  gridStore.setStoreData(globalStore.modal.contentObject.similarCompanies);

  globalStore.reorderColumns(TableType[TableType.similarCompany], grid.value.instance.value.columns);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref($t)("popups.providerManagement.selectedSimilarProvider")), 1),
    _createTextVNode(" " + _toDisplayString(_unref(currentSelectedProviderCompany).name), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(currentSelectedProviderCompany).street) + " " + _toDisplayString(_unref(currentSelectedProviderCompany).streetnumber), 1),
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString(_unref(currentSelectedProviderCompany).zip) + " " + _toDisplayString(_unref(currentSelectedProviderCompany).city), 1),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_unref(currentSelectedProviderCompany).dialCode) + _toDisplayString(_unref(currentSelectedProviderCompany).phoneNumber), 1),
    _hoisted_5,
    _createElementVNode("button", {
      class: "btn mt-2",
      onClick: openEditWithEnteredCompanyData
    }, _toDisplayString(_unref($t)("popups.providerManagement.editInsertedData")), 1),
    _hoisted_6,
    _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref($t)("popups.providerManagement.chooseAvailableProvider")), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(GridInputFilter), {
            gridStore: _unref(gridStore),
            hideFilterButton: true
          }, null, 8, ["gridStore"])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ])
  ]))
}
}

})